import queryString, {stringify} from 'query-string';
import { push, replace } from 'react-router-redux';
import { Map } from 'immutable';
import getSection, { findByPathName } from './section';
import getAlias, { findByQuery } from './aliases';
import { SALE, APARTMENTS, VIEW_MODE } from '../consts';

export function getHomeUrl (dealType, realtyType) {
  if (dealType === SALE && realtyType === APARTMENTS) {
    return '/';
  }
  const sectionUrl = getSection(dealType, realtyType).get('url');
  return sectionUrl.get('home');
}

export function getCardUrl (dealType, realtyType) {
  const sectionUrl = getSection(dealType, realtyType).get('url');
  return sectionUrl.get('base') + sectionUrl.get('card');
}

export function getSearchUrl (dealType, realtyType) {
  const sectionUrl = getSection(dealType, realtyType).get('url');
  return sectionUrl.get('base') + sectionUrl.get('search');
}

export function getLocationByFilter (filter, dealType, realtyType) {
  let f = filter || new Map({});

  const hasPrice = !!(f.get('priceMin') || f.get('priceMax'));

  if (!hasPrice) {
    f = f.set('priceUnitId', null);
  }

  const query = pureFilter(f);
  const pathname = getSearchUrl(dealType, realtyType);

  let redirectPathName;

  if (!query.isEmpty()) {
    let alias = getAlias(pathname);

    if (alias) {
      if (query.equals(alias.get('query'))) {
        redirectPathName = pathname;
      } else {
        const pathnameSection = getSearchUrl(alias.get('dealType'), alias.get('realtyType'));
        redirectPathName = pathnameSection + '?' + stringify(alias.get('query').merge(query).toJS());
      }
    } else {
      const section = findByPathName(pathname);

      if (section) {
        let aliasPath = findByQuery(section.dealType, section.realtyType, query);
        if (aliasPath) {
          redirectPathName = aliasPath;
        }
      }
    }
  }

  if (redirectPathName) {
    return redirectPathName;
  }

  const queryJs = stringify(query.toJS());
  return pathname + (queryJs ? '?' + queryJs : '');
}

export function getLocationByDealHandler (dealType, realtyType) {
  return getHomeUrl(dealType, realtyType);
}

export function updateLocation (storePath, state, dispatch) {
  const currentLocation = state.getIn(['routing', 'location']).toJS();
  let nextLocation = currentLocation.pathname;

  const alias = getAlias(currentLocation.pathname);
  let query = pureFilter(state.getIn([storePath, 'filter']));
  let clearQuery = query.remove('page').remove('per-page').remove('viewMode').remove('bounds');

  if (!query.isEmpty()) {
    if (alias) {
      if (clearQuery.equals(alias.get('query'))) {
        const ignore = alias.get('query');
        query = query.filter((v, k) => ignore.get(k) !== v);
        nextLocation = currentLocation.pathname + (query.size ? '?' + queryString.stringify(query.toJS()) : '');
      } else {
        const pathname = getSearchUrl(alias.get('dealType'), alias.get('realtyType'));
        nextLocation = pathname + '?' + queryString.stringify(alias.get('query').merge(query).toJS());
      }
    } else {
      const section = findByPathName(currentLocation.pathname);

      if (section) {
        let aliasPath = findByQuery(section.dealType, section.realtyType, clearQuery);
        if (aliasPath) {
          nextLocation = aliasPath;
        } else {
          nextLocation = section.path + '?' + queryString.stringify(query.toJS());
        }
      }
    }
  } else if (alias) {
    const pathname = getSearchUrl(alias.get('dealType'), alias.get('realtyType'));
    if (pathname) {
      nextLocation = pathname;
    }
  }

  const browserLocation = process.env.BROWSER ? (window.location.pathname + window.location.search) : null;

  if (nextLocation && nextLocation !== browserLocation) {
    dispatch(push(nextLocation));
  } else {
    dispatch(replace(nextLocation));
  }
}

export function pureFilter (data) {
  const params = data.filter((val, key) => {
    if (key === 'page' && val === 1) {
      return false;
    }
    if (key === 'per-page' && (val === 50 || val === 30)) {
      return false;
    }
    if (key === 'viewMode' && val === VIEW_MODE.grid) {
      return false;
    }

    return val !== null;
  });

  return params;
}

export function getPrevRelPage (currentPage, url) {
  const prev = currentPage > 1 ? currentPage - 1 : null;
  if (!prev) {
    return false;
  }

  if (prev === 1) {
    return url.replace(/[?&]page=\d+/, '');
  }

  return url.replace(/([?&]page=)\d+/, '$1' + prev);
}

export function getNextRelPage (currentPage, totalPages, url) {
  const next = currentPage < totalPages ? currentPage + 1 : null;

  if (!next) {
    return false;
  }

  if (url.search(/[?&]page=\d/i) === -1) {
    return url + (url.charAt(0) === '?' ? '&' : '?') + 'page=' + next;
  }

  return url.replace(/([?&]page=)\d+/, '$1' + next);
}

export function getUrlWithSize (url, size) {
  return url.replace('{{ size }}', size);
}



// WEBPACK FOOTER //
// ./src/utils/urls.js